// Outgoing-SMS compliance footer.
//
// Every text we send through Twilio must carry an automated-message disclosure
// (state law), and outreach messages an opt-out line. Twilio's number auto-
// handles the actual STOP keyword; this just makes sure the copy is present and
// consistent. Route EVERY sendSms(...) body through composeSms() so nothing
// goes out non-compliant.
//
// De-dupes any inline "Reply STOP…" a caller's message already had, so wrapping
// an existing message is safe.
export function composeSms(core) {
  const body = String(core || '')
    .replace(/\s*Reply\s+STOP\s+to\s+opt\s*out\.?\s*/gi, ' ')
    .replace(/[ \t]{2,}/g, ' ')
    .trim();
  return body + '\n\n(Automated message from 3C Detailing. Reply STOP to opt out.)';
}
